// extracted by mini-css-extract-plugin
export default {"nav-back-icon":"MediaGallery_nav-back-icon__no3wB","media-content-wrapper":"MediaGallery_media-content-wrapper__V2Yfx"};